import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'radio-button',
    standalone: true,
    imports: [RadioButtonModule, TranslateModule, FormsModule],
    templateUrl: './radio-button.component.html',
    styleUrl: './radio-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioButtonComponent {
    name = input.required<string>();
    model = model.required<any>();
    options = input.required<
        {
            id: string;
            label: string;
            value: any;
            disabled?: boolean;
        }[]
    >();

    disabled = input<boolean>(false);
    inline = input<boolean>(true);
}
